import React, { useRef } from 'react';
import { Box } from '@mui/material';
import Page1 from "./MobilePages/Page1";
import Page2 from "./MobilePages/Page2";
import Page3 from "./MobilePages/Page3";
import Page4 from "./MobilePages/Page4";
import Page5 from "./MobilePages/Page5";

const Mobileview = () => {
    const page1Ref = useRef(null);
    const page5Ref = useRef(null);

    const scrollToPage1 = () => {
        if (page1Ref.current) {
            page1Ref.current.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
            });
        }
    };

    const scrollToPage5 = () => {
        if (page5Ref.current) {
            page5Ref.current.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'start' 
            });
        }
    };

    return (
        <Box sx={{ scrollBehavior: 'smooth' }}>
            <div ref={page1Ref}>
                <Page1 onJoinClick={scrollToPage5} onLogoClick={scrollToPage1} />
            </div>
            <Page2 />
            <Page3 />
            <Page4 />
            <div ref={page5Ref}>
                <Page5 />
            </div>
        </Box>
    );
};

export default Mobileview;